import cn from 'classnames';
import React from 'react';
import IconCaretDown from '../components/icon/IconCaretDown';
import {Menu, Transition} from '@headlessui/react'

type Props = {
  caption?: string
  className?: string
  narrow?: boolean
  onButtonClick?: () => void
}

export default function DropdownActionMenu({
                                             caption, onButtonClick, narrow, ...props
                                           }: React.PropsWithChildren<Props>) {

  const extraButton = !!caption;

  return (
    <span className="relative z-10 inline-flex shadow-sm rounded-md bg-blue self-center">
      {extraButton && <>
        <button
          className="inline-flex items-center px-4 py-2 text-white rounded-l-md transition duration-150 ease-in-out focus:outline-none focus:border-blue-focus focus:ring-blue active:bg-blue-press hover:bg-blue-hover"
          onClick={onButtonClick}>
          {caption}
        </button>
        <span className="border-l-2 self-center py-4 border-white opacity-40"></span>
      </>}
      <Menu as="span" className="relative block">
        <Menu.Button
          className={cn("h-full px-4 py-2 text-white rounded-r-md " +
            "transition duration-150 ease-in-out focus:outline-none focus:border-blue-focus " +
            "focus:ring-blue active:bg-blue-press hover:bg-blue-hover", {"rounded-l-md": !extraButton})}
        >
          <span className={cn({"hidden": extraButton}, "mr-2")}>Actions</span>
          <IconCaretDown className="text-white inline-block -mt-0.5" height="4"/>
        </Menu.Button>

        <Transition
          as={React.Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1"
        >
          <Menu.Items className={cn("select-none absolute z-10 mt-3 px-0", {
            "-ml-52": extraButton && !narrow,
            "-ml-40": extraButton && narrow,
            "w-64 -ml-36": !narrow,
            'w-48 -ml-24': narrow
          })}>
            <div className="rounded-md shadow-lg ring-1 ring-gray ring-opacity-20 overflow-hidden bg-white">
              {props.children}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </span>
  );
}
